/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2021 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { withTheme } from "@material-ui/core/styles";
import styled from "styled-components";

import StyledTextField from "./StyledTextField";

const StyledAutoComplete = styled(Autocomplete)`
  .MuiAutocomplete-input {
    color: ${(props) => props.theme.palette.primary.dark};
  }
`;

const CarrierAutoComplete = ({
  theme,
  setCarrierId,
  carrierId,
  disableClearable,
  isDisabled,
}) => {
  const { carriers, isFetching } = useSelector((state) => {
    return state.carriers;
  });
  const handleChange = (event, option) => {
    setCarrierId(option?.id ?? null);
  };

  const getCarrier = () => {
    const carrier = carrierId
      ? carriers.find((obj) => obj.id === parseInt(carrierId, 10))
      : null;

    return carrier ? { id: carrierId, carrierName: carrier.carrierName } : null;
  };

  return (
    <StyledAutoComplete
      value={getCarrier()}
      getOptionLabel={(option) => option.carrierName}
      options={carriers ? carriers : []}
      disabled={isFetching || isDisabled}
      onChange={(event, option) => handleChange(event, option)}
      theme={theme}
      data-testid="carrier-autocomplete"
      getOptionSelected={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <StyledTextField {...params} label="Carrier" variant="outlined" />
      )}
      disableClearable={disableClearable}
    />
  );
};

export default withTheme(CarrierAutoComplete);

CarrierAutoComplete.propTypes = {
  setCarrierId: PropTypes.func.isRequired,
  carrierId: PropTypes.number,
  disableClearable: PropTypes.bool,
  isDisabled: PropTypes.bool,
};
